import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_IdDdWaiverReqForAdditionalBhSuppSvs = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_IdDdWaiverReqForAdditionalBhSuppSvs' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>ID/IDD Waiver Request for Additional Behavior Support Services</h3></p>
                <p className='w-750'><h4>(Use as many pages as necessary and attach most recent Quarterly Review Report)</h4></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'># Additional Hours Requested:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'># Hours utilized to date:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAdditional' name='txtAdditional' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='date' id='txtHours' name='txtHours' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Target behavior(s):</span>
                    <textarea id='txtTarget' name='txtTarget' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Justification for additional services:</span>
                    <span className='small'>(why hours are needed and how they will be used)</span>
                    <textarea id='txtJustification' name='txtJustification' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Desired goals/outcomes:</span>
                    <textarea id='txtDesired' name='txtDesired' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>BIDD USE ONLY</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Approved </span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Disapproved</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbActive_Yes' name='rbActive' className='add-only' value='1' />
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbActive_No' name='rbActive' className='add-only' value='0' />
                        </td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











